<template>
    <div class="footer modulewrap">
        <div class="copyright realwrap">
            <ffcontent alias="telfort_footer"></ffcontent>
        </div>
    </div>
</template>
